// 2026 redesign design-kit tokens (web). Mirrors the mobile kit
// (packages/mobile/src/Theme.ts `kit` + `radius`) and the approved mockup CSS
// variables (--ink, --slate, --amber, ...). Plain module so non-theme
// consumers (sx props, charts, plain CSS-in-JS) can import values directly.

export const kit = {
  blue: '#1CA7E5', // --blue (brand)
  blueInk: '#0C82BD', // --blue-ink (text/icon on a blue tint)
  blueTint: '#EAF6FD', // --blue-tint (soft blue surface)
  ink: '#13212E', // --ink (primary text)
  inkSoft: '#33424E', // --ink-soft (strong secondary text)
  slate: '#65717C', // --slate (secondary text)
  slate2: '#9BA6AF', // --slate-2 (tertiary text / placeholders)
  mist: '#F3F6F8', // --mist (neutral surface)
  line: '#E6EBEF', // --line (hairline borders)
  amber: '#E0972F', // --amber (pending / attention)
  amberTint: '#FBF1DF', // --amber-tint
  green: '#16A77A', // --green (success / money-held-safe)
  greenTint: '#E6F6F0', // --green-tint
  purple: '#A373E8', // --purple (AI surfaces)
  purpleTint: '#F0EDFE', // --purple-tint
  danger: '#E0594B', // --red (destructive actions, e.g. ActionRowsCard danger row)
  // No --red-tint exists in the approved mockup CSS (--red is only ever used as
  // a text/icon color, never a tinted surface). Derived here at the same
  // ~90/10 white/color blend the other *Tint tokens use, for the day a danger
  // surface (not just danger text) is needed.
  dangerTint: '#FCEEED',
} as const;

// Corner-radius scale (px).
export const radius = {
  sm: 10,
  md: 12,
  lg: 16,
  xl: 20,
  pill: 999,
} as const;

// Kit font stacks. Family names match the @font-face declarations in
// src/App.css and src/Theme.ts ('AeonikProReqular' misspelling included --
// that IS the registered family name).
export const fonts = {
  sans: "'AeonikProReqular', sans-serif",
  serif: "'TiemposTextRegular', serif",
} as const;

// Numeric breakpoints from the approved responsive rulebook
// (web-tab-rules.html) that fall between the theme's named breakpoints
// (xs 0 / sm 601 / md 1024 / lg 1440 / xl 1920 -- see packages/web/src/Theme.ts).
// Use with theme.breakpoints.up/down/between(...), e.g.
// theme.breakpoints.up(breakpoint.tablet) -- NOT window.innerWidth.
export const breakpoint = {
  // Phone (<=767) vs tablet (>=768): topbar collapses to logo+bell+avatar
  // and hands nav off to BottomTabBar below this line; PhotoStrip and the
  // HeroStatusCard action row also key off it.
  tablet: 768,
  // Small desktop (1024-1279, fluid, 320px rail) vs desktop (>=1280, capped
  // at 1200 centered, 360px rail) -- PageShell's two-column band.
  desktop: 1280,
} as const;

export type KitColorKey = keyof typeof kit;
export type RadiusKey = keyof typeof radius;
